<template>
  <DashboardComponent />
</template>

<script>
import DashboardComponent from "@/sections/voiceplus/components/DashboardComponent.vue";
import config from "@/config";

export default {
  name: "Dashboard",
  components: { DashboardComponent },
  data: function () {
    return {
      sections: config.Sites,
    };
  },
};
</script>
